import { Component } from 'vue-property-decorator';
import {
  GetDeliveryCompaniesRequest,
  PayType,
  AdditionalPayType,
  GetClaimsOrdersOrderNoRefundsRequest,
  GetClaimsOrdersOrderNoAdditionalPaysRequest,
} from 'supporter';
import OrderDetailBase from '@/components/common/order/mixins/OrderDetailBase';
import { addProductDetailUrlPreview } from '@/utils/formatUtils';
import { namespace } from 'vuex-class';
import { ValueNameType } from '@/store/modules/orderEnums';
import { convertProductUri } from '@/utils/commonUtils';

const orderEnumsModule = namespace('orderEnums');

@Component
export default class OrderDetailMixin extends OrderDetailBase {
  @orderEnumsModule.Getter('payTypeMap')
  private readonly payTypeMap!: ValueNameType[];

  public productInfo: any[] = [];
  public paymentInfo: any[] = [];
  public deliveryCompanyTypeArr: any[] = [];
  public deliveryCompanyType: any = {
    value: undefined,
  };
  public invoiceTex: any = null;
  public shippingResp: any[] = [];
  public shippingNosArr: any[] = [];

  public endPayInfo: any = {};
  public onlyInitPay: boolean = true;
  public onlyInitPayClaimStatusType: any[] = [
    'CANCEL_DONE',
    'RETURN_DONE',
    'EXCHANGE_DONE_PAY_DONE',
    'EXCHANGE_DONE',
    'EXCHANGE_DONE_REFUND_DONE',
    'RETURN_NO_REFUND',
  ]; // 최종결제정보

  public mallName: any = null;
  public showReturnList: boolean = false;
  public retrunListNum: any = null;

  public totalAccumulation: any = 0;
  public editReturnPay: any = 0;
  public memberInfo: any = {};
  public receiverListContent: any[] = [];
  public taskContentLength: any = 0;
  public csContentLength: any = 0;
  public serviceNo: any = null;
  public allCsLog: boolean = true;
  public orderInfoPayType: any = '';
  public orderPayType: any = '';
  public orderPayDetailInfo: any = '';
  public orderPayCashStatus: any = '';
  public orderPayCashUrl: any = '';
  public orderPayInsruanceStatus: any = '';
  public orderPayInsruanceUrl: any = '';
  public orderPayPayYmdt: any = '';
  public orderPayPaymentInfo: any = {};
  public returnContentList: any = [];
  public returnDetailList: any = [];
  public otherPayDetailList: any = [];
  public returnListFlagArr: any = [
    'CANCEL_DONE',
    'CANCEL_PROC_REQUEST_REFUND',
    'RETURN_DONE',
    'EXCHANGE_DONE_REFUND_DONE',
    'RETURN_NO_REFUND',
  ]; // 환불 정보
  public otherPayListFlagArr: any = ['EXCHANGE_REQUEST', 'EXCHANGE_DONE_PAY_DONE']; // 추가 결제

  public showOtherPayList: boolean = false;
  public showAllTaskList: boolean = false;
  public taskProcessNum: number = 0;
  public taskTotalNum: number = 0;
  public csProcessNum: number = 0;
  public csTotalNum: number = 0;
  public showNaverPayDetail: boolean = false;
  public showReturnDetail: boolean = false;
  public returnDetailInfo: any = {};
  // TODO: 네이버페이 주문 건 처리 안내 레이어 팝업 마크업 요청함
  public naverPayData: any = {
    id: 'naverPayGuide',
    width: 800,
    maxHeight: 500,
    title: '네이버페이 주문 건 처리 안내',
    nonFooter: true,
    hasConfirmBtn: false,
  };
  public returnDetailData: any = {
    id: 'issuableCouponLayer',
    width: 600,
    maxHeight: 500,
    title: 'ORDER_ORDER_DETAIL_LAYER_POP_RETURN_TITLE',
    nonFooter: true,
    hasConfirmBtn: false,
  };
  public showProductDetail: boolean = false;
  public productLayerData: any = [];
  public productDataPop: any = {
    id: 'setOption',
    width: 800,
    maxHeight: 500,
    title: '세트상품 상세',
    nonFooter: false,
    hasConfirmBtn: false,
    hasCloseBtn: true,
  };
  public showTheProductLayer(data: any): void {
    this.productLayerData = [];
    this.productLayerData = data;
    this.showProductDetail = true;
  }
  public showRetrunDetailPop(data: any): void {
    this.returnDetailInfo = {};
    this.returnDetailInfo = data;
    this.showReturnDetail = true;
  }
  public taskMessageInfo: any[] = [
    {
      orderOptionNo: 0,
      taskMessageStatus: '',
    },
  ];

  public handleLayerOpen(data: any): void {
    const uri = convertProductUri(this.productUrl, data.theMallProductNo);
    window.open(uri);
  }
  public initTask(): void {
    this.task.taskMessageStatus = 'PROCESSING';
    this.task.taskMessageType = 'PRODUCT';
    this.task.taskMessageTargetType = 'PARTNER';
    this.task.orderProductOptionNo = undefined;
    this.task.content = null;
  }

  public initCs(): void {
    this.cs.csStatusType = 'PROCESSING';
    this.cs.csType = 'PRODUCT';
    this.cs.csPathType = 'IN_BOUND';
    this.cs.orderProductOptionNo = undefined;
    this.cs.content = null;
  }

  public handleTaskNum(pNum: any, tNum: any): void {
    this.taskProcessNum = pNum;
    this.taskTotalNum = tNum;
  }
  public handletaskMessageStatus(data: any) {
    data.map((item: any, index: number): any => {
      if (item.taskMessageStatusType === 'PROCESSING') {
        this.taskMessageInfo[index] = {
          orderOptionNo: item.orderProductOptionNo,
          taskMessageStatus: item.taskMessageStatusType,
        };
      }
    });
  }
  public getOtherPayList(): void {
    let request: GetClaimsOrdersOrderNoAdditionalPaysRequest = {
      pathParams: {
        orderNo: this.$route.query.orderNo as string,
      },
    };
    this.$api
      .getClaimsOrdersOrderNoAdditionalPays(request)
      .then((res): any => {
        this.otherPayDetailList = [];
        if (res.data.length > 0) {
          res.data.map((item: any): any => {
            this.productInfo.map((itemP: any): any => {
              if (itemP.claimNo === item.claimNo && this.otherPayListFlagArr.indexOf(itemP.claimStatusType) > -1) {
                item.payAmt = item.payAmt.toLocaleString();
                this.otherPayDetailList.push(item);
              }
            });
          });
        }
      })
      .finally((): any => {
        this.showOtherPayList = this.otherPayDetailList.length > 0;
      });
  }
  public getUsePaymentInfo(arr: any): void {
    if (arr.length === 0) {
      return;
    }
    arr.map((item: any): any => {
      if (item.firstPay) {
        this.orderPayType = item.payType;
        this.orderInfoPayType = this.payTypeLabel(item.payType);
        this.orderPayDetailInfo = item.detailString;
        this.orderPayCashStatus = item.cashReceiptStatus;
        this.orderPayCashUrl = item.cashReceiptUrl;
        this.orderPayPayYmdt = item.payYmdt;
        this.orderPayPaymentInfo = item.paymentInfo;
      }
    });
  }
  public taskContentInput(): void {
    if (this.task.content) {
      this.taskContentLength = this.task.content.length;
    } else {
      this.taskContentLength = 0;
    }
  }
  public csContentInput(): void {
    if (this.cs.content) {
      this.csContentLength = this.cs.content.length;
    } else {
      this.csContentLength = 0;
    }
  }
  public getTaskProductOptions(): void {
    const getItemLabel = ({ productColor, productSize, productName, optionName, optionValue, isFreeGift }) => {
      const _productName = `${isFreeGift ? '(사은품) ' : ''}${productName}`;

      if (productColor && productSize) {
        return `${_productName} | ${productColor} | ${productSize}`;
      }
      return `${_productName} | ${optionName} : ${optionValue}`;
    };

    this.orderProductOptionNoArr = this.productInfo.map(({ orderOptionNo, partnerNo, ...product }) => ({
      value: orderOptionNo,
      label: getItemLabel(product),
      partnerNo: partnerNo,
    }));
  }
  public formatterProductOption(data: any): void {
    if (data.length === 0) {
      return;
    }
    data.map((item: any): any => {
      if (item.optionName.split('|').length > 1 && item.optionValue.split('|').length > 1) {
        let color: any = item.optionName.split('|')[0] + ':' + item.optionValue.split('|')[0];
        let size: any = item.optionName.split('|')[1] + ':' + item.optionValue.split('|')[1];
        this.$set(item, 'productColor', color);
        this.$set(item, 'productSize', size);
      } else {
        this.$set(item, 'productColor', item.optionName);
        this.$set(item, 'productSize', item.optionValue);
      }
    });
  }

  public handleEmitShippingResp(data: any): void {
    this.receiverListContent = [];
    this.receiverListContent = data;
  }
  public getOrderMemberInfo(data: any): void {
    this.$set(this.memberInfo, 'name', data.orderer.name);
    this.$set(this.memberInfo, 'email', data.orderer.email);
    this.$set(this.memberInfo, 'contact1', data.orderer.contact1);
    this.$set(this.memberInfo, 'memberNo', data.memberNo);
    this.$set(this.memberInfo, 'memberType', data.memberNo === 0 ? 'guest' : 'member');
  }
  public getTotalAccumulation(arr: any): void {
    if (arr.length === 0) {
      return;
    }
    this.totalAccumulation = 0;
    arr.map((item: any): any => {
      this.totalAccumulation += Number(item.expectedAccumulationAmount);
    });
    this.totalAccumulation = this.totalAccumulation.toLocaleString();
  }
  public getReturnListAndPayList(): void {
    let request: GetClaimsOrdersOrderNoRefundsRequest = {
      pathParams: {
        orderNo: this.$route.query.orderNo as any,
      },
    };
    this.$api.getClaimsOrdersOrderNoRefunds(request).then((res): any => {
      let editReturnPay = 0;
      this.returnContentList = res.data;
      this.returnContentList.map((item: any): any => {
        editReturnPay += Number(item.refundAmounts.refundAdjustAmt);
        this.productInfo.map((itemP: any): any => {
          if (item.claimNo === itemP.claimNo && this.returnListFlagArr.indexOf(itemP.claimStatusType) > -1) {
            this.returnDetailList.push(item);
          }
        });
      });

      this.endPayInfo.editReturnPay = editReturnPay;
      this.returnDetailList.map((item: any): any => {
        if (item.refundBankAccount) {
          item.refundBankAccount.account = item.refundBankAccount.account || '';
          item.refundBankAccount.depositorName = item.refundBankAccount.depositorName || '';
        }

        let claimFinishedArr: any = [];
        claimFinishedArr = this.productInfo.filter((itemP: any): any => {
          return itemP.claimNo === item.claimNo;
        });
        if (claimFinishedArr.length > 0) {
          this.$set(item, 'claimFinished', claimFinishedArr[0].claimFinished);
        }
      });

      // 클레임 번호 중복되는 환불정보 제거
      this.returnDetailList = this.returnDetailList.reduce((acc, returnDetail): any => {
        return acc.includes(returnDetail) ? acc : [...acc, returnDetail];
      }, []);

      if (this.returnDetailList.length > 0) {
        this.retrunListNum = this.returnDetailList.length;
        this.showReturnList = true;
      } else {
        this.showReturnList = false;
        this.retrunListNum = 0;
      }
    });
  }
  public handleOrderInfo(data: any): void {
    this.mallName = this.getMallName(data.mallNo, this.malls);
    this.$set(this.orderInfo, 'registerYmdt', data.registerYmdt);
    this.$set(this.orderInfo, 'mallName', this.mallName);
    this.$set(this.orderInfo, 'orderMemo', data.orderMemo);
    this.$set(this.orderInfo, 'mallNo', data.mallNo);
    this.$set(this.orderInfo, 'orderNo', data.orderNo);
    this.$set(this.orderInfo, 'externalOrderNo', data.externalOrderNo);
  }
  public getMallName(mallNo: any, arr: any): any {
    if (arr.length === 0) {
      return;
    }
    let mallName: any = '';
    arr.forEach((item: any): any => {
      if (item.mallNo === mallNo) {
        mallName = item.mallName;
      }
    });
    return mallName;
  }
  public getPayInfo(data: any): void {
    if (data.length === 0) {
      return;
    }
    data.forEach((item: any): any => {
      if (this.onlyInitPayClaimStatusType.indexOf(item.claimStatusType) > -1) {
        this.onlyInitPay = false;
      }
    });
  }

  public additionalPayType(type: AdditionalPayType | null): any {
    let label: any = '';
    switch (type) {
      case 'CASH':
        label = this.$t('ORDER_ORDER_DETAIL_PAY_TYPE_ACCOUNT');
        break;
      case 'ACCUMULATION':
        label = this.$t('ORDER_ORDER_DETAIL_PAY_TYPE_ACCUMULATION');
        break;
      case 'NAVER_PAY':
        label = this.$t('ORDER_ORDER_DETAIL_PAY_TYPE_NAVER_PAY');
        break;
      default:
        label = '';
    }

    return label;
  }

  public payTypeLabel(type: PayType | null): any {
    return this.payTypeMap.find(({ value }) => value === type)?.name ?? '';
  }
  public getDeliveryCompanies(): void {
    let request: GetDeliveryCompaniesRequest = {
      params: {
        countryCd: 'KR',
      },
    };
    this.$api.getDeliveryCompanies(request).then((res): any => {
      this.deliveryCompanyTypeArr = [...res.data];
    });
  }

  public getProductUrl(data: any): void {
    if (data.length === 0) {
      return;
    }

    this.$api.getProductsDetailUrls().then((res: any): any => {
      let arr: any = [];
      arr = res.data.filter((item: any): any => {
        return item.mallNo === data[0].mallNo;
      });

      this.productUrl = arr[0] ? addProductDetailUrlPreview(arr[0].url) : '';
    });
  }
  public handleTheCsNums(allNum: any, processingNum: any): void {
    this.csProcessNum = processingNum;
    this.csTotalNum = allNum;
  }
  public orderRegisterTypeLabel(type: any): any {
    let name: any = '';
    switch (type) {
      case 'NORMAL':
        name = this.$t('ORDER_ORDER_DETAIL_REGISTER_TYPE_NORMAL');
        break;
      case 'ADMIN':
        name = this.$t('ORDER_ORDER_DETAIL_REGISTER_TYPE_ADMIN');
        break;
      case 'ARIEL':
        name = this.$t('ORDER_ORDER_DETAIL_REGISTER_TYPE_ARIEL');
        break;
      case 'RECURRING_PAYMENT':
        name = this.$t('ORDER_ORDER_DETAIL_REGISTER_TYPE_RECURRING_PAYMENT');
        break;
      default:
        name = '';
    }
    return name;
  }
}
